<template>
  <div class="clear" />
  <div class="middle">
    <div class="cont">
      <h1 class="pageTitle">会社情報</h1>
      <div class="compInf clear">
        <table>
          <tr>
            <th>社名</th>
            <td>株式会社シンクスカイ</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>千葉県船橋市浜町2ー3ー34ー1203</td>
          </tr>
          <tr>
            <th>設立</th>
            <td>平成19年6月</td>
          </tr>
          <tr>
            <th>資本金</th>
            <td>1000万円</td>
          </tr>
          <tr>
            <th>役員</th>
            <td>代表取締役&nbsp;朴光哲</td>
          </tr>
          <tr>
            <th>事業内容</th>
            <td>コンピューターソフトウェアの企画、設計、製作、販売</td>
          </tr>
          <tr>
            <th>電話</th>
            <td>047-432-6066</td>
          </tr>
          <tr>
            <th>Eメール</th>
            <td><a href="mailto:info@think-sky.com">info@think-sky.com</a></td>
          </tr>
        </table>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>

<script>
export default {
  setup(){

  }
}
</script>